<template>
    <div class="edition-modal modal fade" v-bind:id="id" tabindex="-1" v-bind:aria-labelledby="id" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content"  v-if="model">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="model != null && model.id && editTitle">{{ editTitle }}</h5>
                    <h5 class="modal-title" v-if="model != null && !model.id && createTitle">{{ createTitle }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" v-bind:aria-label="$t('ui.edition_modal.close_button')"></button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" v-on:click="handleCancelButtonClicked()" >{{ $t("ui.edition_modal.cancel_button") }}</button>
                    <button type="button" class="btn btn-primary" v-on:click="handleSaveButtonClicked()">{{ $t("ui.edition_modal.save_button") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditionModal",

    props: {
        id: String,
        model: Object,
        editTitle: String,
        createTitle: String
    },

    data() {
        return {
            modal: null
        }
    },

    methods: {
        handleCancelButtonClicked() {
            this.$emit("cancel", this.id);
        },

        handleSaveButtonClicked() {
            this.$emit("save", this.id);
        },

        show() {
            this.modal.show();
        },

        hide() {
            this.modal.hide();
        }
    },

    mounted() {
        this.modal = new this.bootstrap.Modal(document.getElementById(this.id));
    }
}
</script>

<style scoped>

</style>